package music.jammers.client.shared.component

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.base_background
import org.jetbrains.compose.resources.painterResource

@Composable
fun BackgroundBox(content: @Composable () -> Unit) {
    Box(
        modifier = Modifier
            .fillMaxSize()
    ) {
        Image(
            painterResource(Res.drawable.base_background),
            contentDescription = "Background",
            contentScale = ContentScale.Crop,
            modifier = Modifier.align(Alignment.Center)
                .fillMaxSize(),
        )

        CenterBox(content = content)
    }
}